import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { memo } from 'react';
var Root = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center'
});
export var Loading = /*#__PURE__*/ memo(function() {
    var getTestId = useTestId().getTestId;
    return /*#__PURE__*/ _jsx(Root, {
        "data-testid": getTestId('loading'),
        children: /*#__PURE__*/ _jsx(CircularProgress, {
            color: "primary"
        })
    });
});
